import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { FacilitySelectionBehaviour } from './local-settings'

@Directive({
  selector: '[appFacilitySelectionBehaviourSelect]',
})
export class FacilitySelectionBehaviourSelect {
  private select = inject(ElderSelectComponent)
  readonly enumTranslationService = inject(ElderEnumTranslationService)

  constructor() {
    const enumTranslationService = this.enumTranslationService

    this.select.displayProperty = 'displayValue'
    this.select.nullDisplay = 'context.noSelection'
    this.select.dataSource = enumTranslationService.enumDataSource(
      FacilitySelectionBehaviour,
      'settings.facilities.behaviour'
    )
  }
}
